import { observable, computed, action, makeObservable } from "mobx";
class SettingStore {
  constructor() {
    makeObservable(this);
  }

  @observable
  _st_version = "1.0";

  get getVersion() {
    return this._st_version;
  }
  @observable
  /*dev, staging, real*/
  _st_active =
    process.env.REACT_APP_ENV === "production" ? "real" : process.env.REACT_APP_ENV === "staging" ? "staging" : "dev";

  get getActive() {
    return this._st_active;
  }

  @action
  setActive(active) {
    this._st_active = active;
  }

  @observable
  _st_active_rest_url = {
    abbitmq: "",
    okgoApi: "",
    tpayApi: "",
    tpayToken:
      "EjYphQSkzqqjLf3d5rrQePeToHngIbarpiGlZMr3Wj3CZsC3TO7SGL7smUI1qU51YPtKghBf6Qc2KCBxe/AgZgy9h4FYe7lfq2fP1R9GbpVfGl8RdmVBbp47IvcSACZajCLkj80bJW5U58YCODt5YesSpNYtyMBymi6I4uPVy5Xnem8YK0pW8+4NFIyOcF4KXBFthIeDbtM10ddTrzTKgBvcQm/9J7W+SeaIEHLPYTA0jA5CECKKGLXwWsg0gLII",
  };

  @computed
  get ActiveRestUrl() {
    localStorage.setItem("apiUrl", "");
    if (this._st_active === "dev") {
      this._st_active_rest_url = {
        ...this._st_active_rest_url,
        abbitmq: "ws://tdum.okpos.co.kr:15674/ws",
        okgoApi: "https://tdum.okpos.co.kr",
        tpayApi: "http://dev-api.tpay.co.kr",
      };
    } else if (this._st_active === "staging") {
      this._st_active_rest_url = {
        ...this._st_active_rest_url,
        abbitmq: "wss://dumqueue.okpos.co.kr:15673/ws",
        okgoApi: "https://sdum.okpos.co.kr",
        tpayApi: "https://api.tpay.co.kr",
      };
    } else if (this._st_active === "real") {
      this._st_active_rest_url = {
        ...this._st_active_rest_url,
        abbitmq: "wss://dumqueue.okpos.co.kr:15673/ws",
        okgoApi: "https://dum.okpos.co.kr",
        tpayApi: "https://api.tpay.co.kr",
      };
    }
    localStorage.setItem("apiUrl", this._st_active_rest_url.okgoApi);
    return this._st_active_rest_url;
  }

  @observable
  _st_out_agency_url = {
    jinjuApi: "",
    nubigoApi: "",
  };

  @computed
  get OutAgencyUrl() {
    if (this._st_active === "dev") {
      this._st_out_agency_url = {
        ...this._st_out_agency_url,
        jinjuApi: "http://smartmarkets.co.kr/okpos/authenticate?shopCd=",
        nubigoApi: "http://smartmarkets.co.kr/okpos/authenticate?shopCd=",
        baeminApi: "https://biz-member.baemin.com/login",
        ygyApi: "https://ceo.yogiyo.co.kr/login",
        naverApi: "https://new.smartplace.naver.com/",
        pandaApi: "https://merchant.hungrypanda.co/login",
        oltteaahApi: "https://admin.oltteaah.com",
        naverBookingApi: "https://new.smartplace.naver.com/",
      };
    } else if (this._st_active === "staging" || this._st_active === "real") {
      this._st_out_agency_url = {
        ...this._st_out_agency_url,
        jinjuApi: "https://m.baedaljinju.com/okpos/authenticate?shopCd=",
        nubigoApi: "https://m.baedaljinju.com/okpos/authenticate?shopCd=",
        baeminApi: "https://biz-member.baemin.com/login",
        ygyApi: "https://ceo.yogiyo.co.kr/login",
        naverApi: "https://new.smartplace.naver.com/",
        pandaApi: "https://merchant.hungrypanda.co/login",
        oltteaahApi: "https://admin.oltteaah.com",
        naverBookingApi: "https://new.smartplace.naver.com/",
      };
    }
    return this._st_out_agency_url;
  }

  @observable
  _st_out_video_url = {};

  // 사용법 영상 링크 (나중에 링크 수정필요)
  @computed
  get OutAgencyVideoUrl() {
    if (this._st_active === "dev") {
      this._st_out_video_url = {
        ...this._st_out_video_url,
        baeminApi: "https://youtu.be/kPbKrY6Q9NI",
        ygySetApi:
          "https://www.youtube.com/watch?v=zOczgHyjSK0/utm_source=OKGO_settingPage&utm_medium=button&utm_campaign=yogiyoSettingManual",
        ygyApi: "https://www.youtube.com/watch?v=6E_X8uprG4I",
        naverApi: "https://new.smartplace.naver.com/",
        ygyEntryApi: "https://partner.yogiyo.co.kr/partner",
        bmEntryApi: "https://ceo.baemin.com/baemin-ad",
        wmpoApi: "https://partner.wmpo.co.kr/",
        ddangyoApi: "https://boss.ddangyo.com/",
        mukApi: "https://boss.mukkebi.com/",
        naverBookingApi: "https://www.youtube.com/watch?v=6E_X8uprG4I",
        default: "https://www.youtube.com/watch?v=zOczgHyjSK0",
      };
    } else if (this._st_active === "staging" || this._st_active === "real") {
      this._st_out_video_url = {
        ...this._st_out_video_url,
        baeminApi: "https://youtu.be/kPbKrY6Q9NI",
        ygySetApi:
          "https://www.youtube.com/watch?v=zOczgHyjSK0/utm_source=OKGO_settingPage&utm_medium=button&utm_campaign=yogiyoSettingManual",
        ygyApi: "https://www.youtube.com/watch?v=6E_X8uprG4I",
        naverApi: "https://new.smartplace.naver.com/",
        ygyEntryApi: "https://partner.yogiyo.co.kr/partner",
        bmEntryApi: "https://ceo.baemin.com/baemin-ad",
        wmpoApi: "https://partner.wmpo.co.kr/",
        ddangyoApi: "https://boss.ddangyo.com/",
        mukApi: "https://boss.mukkebi.com/",
        naverBookingApi: "https://www.youtube.com/watch?v=6E_X8uprG4I",
        default: "https://www.youtube.com/watch?v=zOczgHyjSK0",
      };
    }
    return this._st_out_video_url;
  }

  // 주문접수 및 연동 기본,고급 영상 링크
  @observable
  _st_out_connect_url = {};

  @computed
  get OutAgencyConnectUrl() {
    if (this._st_active === "dev") {
      this._st_out_connect_url = {
        ...this._st_out_connect_url,
        advanced: "",
        basic:
          "https://www.youtube.com/watch?v=RtF3U3OkT1Q/?utm_source=OKGO_settingPage&utm_medium=button&utm_campaign=hookingOperationManual",
      };
    } else if (this._st_active === "staging" || this._st_active === "real") {
      this._st_out_connect_url = {
        ...this._st_out_connect_url,
        advanced: "",
        basic:
          "https://www.youtube.com/watch?v=RtF3U3OkT1Q/?utm_source=OKGO_settingPage&utm_medium=button&utm_campaign=hookingOperationManual",
      };
    }
    return this._st_out_connect_url;
  }

  /*********************/
  /* 화면 VIEW 타입 설정 */
  /*********************/
  /**
   * list(리스트형), card(카드형) 주문 타입
   * @type {string}
   * @private
   */
  @observable
  _st_order_view_type = {
    viewType: "list",
    viewOrder: "asc",
    //soundLevel: "2",
    deliveryDfTime: "60",
    cookingDfTime: "10",
    pickupDfTime: "10",
    autoAcceptFlag: "N",
    autoAcceptDelivery: "N",
    autoAcceptPickup: "N",
    autoAcceptTable: "N",
  };

  /**
   * 주문 타입 조회
   * @returns {string}
   */
  @computed
  get getOrderViewType() {
    return this._st_order_view_type.viewType;
  }

  /**
   * 주문 정렬 조회
   * @returns {*}
   */
  @computed
  get getOrderViewOrder() {
    return this._st_order_view_type.viewOrder;
  }

  /**
   * 사운드 레벨 조회
   * @returns {*}
   */
  @computed
  get getSoundLevel() {
    return this._st_order_view_type.soundLevel;
  }

  /**
   * 배달 기본시간
   * @returns {*}
   */
  @computed
  get getDeliveryDfTime() {
    return this._st_order_view_type.deliveryDfTime;
  }

  /**
   * 조리 기본시간
   * @returns {*}
   */
  @computed
  get getCookingDfTime() {
    return this._st_order_view_type.cookingDfTime;
  }

  /**
   * 픽업 기본시간
   * @returns {*}
   */
  @computed
  get getPickupDfTime() {
    return this._st_order_view_type.pickupDfTime;
  }

  /**
   * 자동 주문 접수
   */
  @computed
  get getAutoAcceptFlag() {
    return this._st_order_view_type.autoAcceptFlag;
  }

  @action
  setPickupDfTime(obj) {
    this._st_order_view_type.pickupDfTime = obj;
  }

  /**
   * 배달 자동접수여부
   * @returns {*}
   */
  @computed
  get getAutoAcceptDelivery() {
    return this._st_order_view_type.autoAcceptDelivery;
  }

  /**
   * 픽업 자동접수여부
   * @returns {*}
   */
  @computed
  get getAutoAcceptPickup() {
    return this._st_order_view_type.autoAcceptPickup;
  }

  /**
   * 테이블 자동접수여부
   * @returns {*}
   */
  @computed
  get getAutoAcceptTable() {
    return this._st_order_view_type.autoAcceptTable;
  }

  /**
   * 설정 전체 객체 수정
   * @param obj
   */
  @action
  setSettingDefaultView(obj) {
    this._st_order_view_type = obj;
  }

  /**
   * 설정 부분 수정
   * @param key
   * @param value
   */
  @action
  async setSettingDefaultViewObj(key, value) {
    this._st_order_view_type = { ...this._st_order_view_type, [key]: value };
  }

  /**
   * 설정 왼쪽 view 여부
   */
  @observable
  _st_setting_view = false;

  get getSettingView() {
    return this._st_setting_view;
  }

  @action
  setSettingView(viewBl) {
    this._st_setting_view = viewBl;
  }

  /**
   * 설정-사용설정 메뉴
   */
  @observable
  _st_setting_use_menu = "";

  get getSettingUseMenu() {
    return this._st_setting_use_menu;
  }

  @action
  setSettingUseMenu(menu) {
    this._st_setting_use_menu = menu;
  }

  /**
   * 매출조회-조회메뉴
   */
  @observable
  _st_setting_sales_menu = "salesList";

  get getSettingSalesMenu() {
    return this._st_setting_sales_menu;
  }

  @action
  setSettingSalesMenu(menu) {
    this._st_setting_sales_menu = menu;
  }

  /**
   * 배달 퀵 주소 정보
   * @type {[]}
   * @private
   */
  @observable
  _st_quick_addr_list = [];

  get getQuickAddr() {
    return this._st_quick_addr_list;
  }

  @action
  setQuickAddr(obj) {
    this._st_quick_addr_list = obj;
  }

  /**
   * 등록 하려는 퀵주소 정보
   * @type {string}
   * @private
   */
  @observable
  _st_quick_addr_curr = "";

  get getQuickAddrCurr() {
    return this._st_quick_addr_curr;
  }

  @action
  setQuickAddrCurr(text) {
    this._st_quick_addr_curr = text;
  }

  /**
   * 프린터 정보 컴포트 관련
   */
  @observable
  _st_comport_list_view = {
    port1: false,
    port2: false,
    printPort: false,
    baudrate: false,
  };

  @computed
  get getComportSelectView() {
    return this._st_comport_list_view;
  }

  @action
  setComportSelectView(key, value) {
    this._st_comport_list_view = { ...this._st_comport_list_view, [key]: value };
  }

  @action
  setComportSelectInitView() {
    this._st_comport_list_view = {
      port1: false,
      port2: false,
      printPort: false,
      baudrate: false,
    };
  }

  /**
   * 기본 프린터 정보 컴포트 관련
   */
  @observable
  _st_default_comport_list_view = false;

  @computed
  get getDefaultComportSelectView() {
    return this._st_default_comport_list_view;
  }

  @action
  setDefaultComportSelectView(bl) {
    this._st_default_comport_list_view = bl;
  }

  @observable
  _st_sound_setting = {
    basicAlarm: "",
    newAlarm: "",
    sendAlarm: "",
    cookingAlarm: "",
    startToPickupLocationAlarm: "",
    unallocatedAlarm: "",
    deliveryAlarm: "",
    pickupAlarm: "",
    naverAlarm: "",
    baeminAlarm: "",
    baemin1Alarm: "",
    baeminStoreAlarm: "",
    baeminPickAlarm: "",
    baeminShopAlarm: "",
    ygyDlvAlarm: "",
    ygyPickAlarm: "",
    ygyShopAlarm: "",
    ygyExpress: "",
    callAlarm: "",
    pandaDlvAlarm: "",
    pandaPickupAlarm: "",
    pandaSelfAlarm: "",
    oltteaahAlarm: "",
    kioskPickAlarm: "",
    kioskShopAlarm: "",
    wmpoAlarm: "",
    ddangyoDlvAlarm: "",
    ddangyoPickAlarm: "",
    ddangbaedalAlarm: "",
    hasamdongcoffeeAlarm: "",
    naverConnectAlarm: "",
    mukkebiDlvAlarm: "",
    mukkebiPickAlarm: "",
    posOrderAlarm: "",
    tableOrderAlarm: "",
    qrOrderAlarm: "",
    soundLevel: "2",
  };

  @computed
  get getSoundPlayInfo() {
    return this._st_sound_setting;
  }
  @action
  setSoundPlayInfo(com) {
    this._st_sound_setting = com;
  }

  @observable
  _init_view = "";

  @computed
  get getInitView() {
    return this._init_view;
  }
  @action
  setInitView(val) {
    this._init_view = val;
  }

  @observable
  kioskOrderYn = "";

  @computed
  get getKioskOrderYn() {
    return this.kioskOrderYn;
  }
  @action
  setKioskOrderYn(val) {
    this.kioskOrderYn = val;
  }

  @observable
  posOrderYn = "";

  @computed
  get getPosOrderYn() {
    return this.posOrderYn;
  }
  @action
  setPosOrderYn(val) {
    this.posOrderYn = val;
  }

  @observable
  dcOrderYn = "";

  @computed
  get getDcOrderYn() {
    return this.dcOrderYn;
  }
  @action
  setDcOrderYn(val) {
    this.dcOrderYn = val;
  }

  @observable
  posType = "";

  @computed
  get getPosType() {
    return this.posType;
  }
  @action
  setPosType(val) {
    this.posType = val;
  }

  @observable
  mainPosYn = "Y";

  @computed
  get getMainPosType() {
    return this.mainPosYn;
  }
  @action
  setMainPosType(val) {
    this.mainPosYn = val;
  }

  @observable
  progressingExposeFlag = "";

  @computed
  get getProgressingExposeFlag() {
    return this.progressingExposeFlag;
  }
  @action
  setProgressingExposeFlag(val) {
    this.progressingExposeFlag = val;
  }

  @observable
  alarmTalkYn = "";

  @computed
  get getAlarmTalkYn() {
    return this.alarmTalkYn;
  }
  @action
  setAlarmTalkYn(val) {
    this.alarmTalkYn = val;
  }

  @observable
  posAlarmtalkYn = "";

  @computed
  get getPosAlarmtalkYn() {
    return this.posAlarmtalkYn;
  }
  @action
  setPosAlarmtalkYn(val) {
    this.posAlarmtalkYn = val;
  }

  @observable
  pagerBellYn = "";

  @computed
  get getPagerBellYn() {
    return this.pagerBellYn;
  }
  @action
  setPagerBellYn(val) {
    this.pagerBellYn = val;
  }

  @observable
  qrAlarmtalkYn = "";

  @computed
  get getQrAlarmtalkYn() {
    return this.qrAlarmtalkYn;
  }
  @action
  setQrAlarmtalkYn(val) {
    this.qrAlarmtalkYn = val;
  }


  @observable
  kitchenPrintYn = "";

  @computed
  get getKitchenPrintYn() {
    return this.kitchenPrintYn;
  }
  @action
  setKitchenPrintYn(val) {
    this.kitchenPrintYn = val;
  }

  @action
  setSoundPlayCheck(key, value) {
    return (this._st_sound_setting = {
      ...this._st_sound_setting,
      [key]: value,
    });
  }

  @observable
  _st_printer_setting = {
    usedComPortForHooking: "",
    kitchenPrinterFlag: "",
    hookingFlag: "",
    outPrinterFlag: "",
    kitchenPrinterType: "",
    availableComPorts: [],
    kitchenPrinterSettings: [],
    usedKitchenPrinterCodes: [],
    etcPrinterFlag: "",
    etcKitchenPrinterFlag: "",
    usedVirtualModeFlag: "",
    usedVirtualModePrintPort: "",
    usedVirtualModePrintBaudrate: "",
    usedVirtualModeVPrint1: "",
    usedVirtualModeVPrint2: "",
    usedVirtualModeExceptPrint: "",
  };

  @computed
  get getPrinterInfo() {
    return this._st_printer_setting;
  }

  @action
  setPrinterInfo(com) {
    this._st_printer_setting = com;
  }

  @action
  setPrinterInfoAvailableComPorts(com) {
    this._st_printer_setting.availableComPorts = com;
  }

  @action
  setPrinterInfoKitchenPrinterSettings(com) {
    this._st_printer_setting.kitchenPrinterSettings = com;
  }

  @computed
  get getUsedComport() {
    return this._st_printer_setting.usedComPortForHooking;
  }

  @action
  setUsedComport(com) {
    this._st_printer_setting.usedComPortForHooking = com;
  }

  @computed
  get getCheckKichenPrinter() {
    return this._st_printer_setting.kitchenPrinterFlag;
  }

  @action
  setCheckKichenPrinter(flag) {
    let val = flag == true ? "Y" : "N";
    this._st_printer_setting.kitchenPrinterFlag = val;
  }

  @action
  setCheckEtcPrinter(flag) {
    let val = flag == true ? "Y" : "N";
    this._st_printer_setting.etcPrinterFlag = val;
  }

  @action
  setCheckEtcKitchenPrinter(flag) {
    let val = flag == true ? "Y" : "N";
    this._st_printer_setting.etcKitchenPrinterFlag = val;
  }

  @computed
  get getCheckEtcPrinter() {
    return this._st_printer_setting.etcPrinterFlag;
  }

  @computed
  get getCheckEtcKitchenPrinter() {
    return this._st_printer_setting.etcKitchenPrinterFlag;
  }

  @computed
  get getCheckKichenPrinterType() {
    return this._st_printer_setting.kitchenPrinterType;
  }

  @action
  setCheckKichenPrinterType(type) {
    this._st_printer_setting.kitchenPrinterType = type;
  }

  @action
  setCheckExceptPrintType(type) {
    this._st_printer_setting.usedVirtualModeExceptPrint = type;
  }

  @action
  setCheckModePrintPortType(type) {
    this._st_printer_setting.usedVirtualModePrintPort = type;
  }

  @action
  setCheckModePrintBaudrate(type) {
    this._st_printer_setting.usedVirtualModePrintBaudrate = type;
  }

  @action
  setCheckPrintPortType1(type) {
    this._st_printer_setting.usedVirtualModeVPrint1 = type;
  }

  @action
  setCheckPrintPortType2(type) {
    this._st_printer_setting.usedVirtualModeVPrint2 = type;
  }

  @computed
  get getCheckHooking() {
    return this._st_printer_setting.hookingFlag;
  }

  @computed
  get getCheckOutPrinter() {
    return this._st_printer_setting.outPrinterFlag;
  }

  @action
  setCheckHooking(flag) {
    let val = flag == true ? "Y" : "N";
    this._st_printer_setting.hookingFlag = val;
  }

  @action
  setCheckOutPrinter(flag) {
    let val = flag == true ? "Y" : "N";
    this._st_printer_setting.outPrinterFlag = val;
  }

  //etc printerSetting
  @observable
  _st_etc_printer_setting = {
    defaultPrintSettings: [],
    addPrintSettings: [],
  };

  @computed
  get getEtcPrinterInfo() {
    return this._st_etc_printer_setting;
  }

  @action
  setEtcPrinterInfo(com) {
    com.defaultPrintSettings.map((obj, index) => {
      obj.index = index;
    });
    this._st_etc_printer_setting = com;
  }

  @action
  setEtcPrinterInfoDefaultPrintSettings(com) {
    this._st_etc_printer_setting.defaultPrintSettings = com;
  }

  //etc printerSetting confirm
  @observable
  _st_etc_printer_setting_confirm = false;

  @computed
  get getEtcPrinterInfoConfirm() {
    return this._st_etc_printer_setting_confirm;
  }

  @action
  setEtcPrinterInfoConfirm(val) {
    this._st_etc_printer_setting_confirm = val;
  }

  @action
  setCheckEtcPrinterDefaultItem(flag, index) {
    let val = flag == true ? "Y" : "N";
    this._st_etc_printer_setting.defaultPrintSettings[index].useYn = val;
  }

  @action
  setCheckEtcPrinterDefaultAddItem(flag, index) {
    let val = flag == true ? "Y" : "N";
    this._st_etc_printer_setting.addPrintSettings[index].useYn = val;
  }

  @action
  setEtcPrintSettings(com) {
    let index = this._st_etc_printer_setting.addPrintSettings.length;
    this._st_etc_printer_setting.addPrintSettings[index] = com;
  }

  @action
  setEtcPrintDefault(key, value, index) {
    return (this._st_etc_printer_setting.defaultPrintSettings[index] = {
      ...this._st_etc_printer_setting.defaultPrintSettings[index],
      [key]: value,
    });
  }

  @action
  setEtcPrintAdd(key, value, index) {
    return (this._st_etc_printer_setting.addPrintSettings[index] = {
      ...this._st_etc_printer_setting.addPrintSettings[index],
      [key]: value,
    });
  }
  /**
   * 주방 요청메시지 정보
   * @type {{}}
   * @private
   */
  @observable
  _st_kitchen_request_memo_asp = [];

  @computed
  get getKitchenRequestMemo() {
    return this._st_kitchen_request_memo_asp;
  }

  @action
  setKitchenRequestMemo(Arr) {
    this._st_kitchen_request_memo_asp = Arr;
  }

  @action
  delKitchenRequestMemo() {
    this._st_kitchen_request_memo_asp = this._st_kitchen_request_memo_asp.filter(
      obj => obj.memo_cd != this._st_request_memo_delete_asp.memo_cd
    );
  }

  /**
   * 고객 요청메시지 정보
   * @type {{}}
   * @private
   */
  @observable
  _st_customer_request_memo_asp = [];

  @computed
  get getCustomerRequestMemo() {
    return this._st_customer_request_memo_asp;
  }

  @action
  setCustomerRequestMemo(Arr) {
    this._st_customer_request_memo_asp = Arr;
  }

  @action
  delCustomerRequestMemo() {
    this._st_customer_request_memo_asp = this._st_customer_request_memo_asp.filter(
      obj => obj.seq != this._st_request_memo_delete_asp.seq
    );
  }

  /**
   * 선택 요청메시지 정보(kitchen, customer)
   * @type {{}}
   * @private
   */
  @observable
  _st_request_memo_delete_asp = {};

  @computed
  get getRequestMemoDelete() {
    return this._st_request_memo_delete_asp;
  }

  @action
  setRequestMemoDelete(obj) {
    this._st_request_memo_delete_asp = obj;
  }

  /**
   * 설정-외부 프로그램 주문 자동 완료
   * 전체 사용/미사용
   */
  @observable
  _st_setting_out_auto = false;

  get getSettingOutAuto() {
    return this._st_setting_out_auto;
  }

  @action
  setSettingOutAuto(flag) {
    this._st_setting_out_auto = flag;
  }

  /**
   * 설정-외부 프로그램 주문 자동 완료
   * 대행사별 사용/미사용
   */
  @observable
  _st_setting_out_auto_prog = [];

  @computed
  get getSettingOutAutoProg() {
    return this._st_setting_out_auto_prog;
  }

  @action
  setSettingOutAutoProg(Arr) {
    this._st_setting_out_auto_prog = Arr;
  }

  @action
  setSettingConfigUseYn(status) {
    this._st_setting_out_auto_prog.forEach(items => {
      items.configUseYn = status ? "Y" : "N";
    });
  }

  @action
  setSettingOutAutoProgUse(rootStore, key, value) {
    let list = rootStore.settingStore.getSettingOutAutoProg;
    list.map((element, index) => {
      if (element.configName == key) {
        this._st_setting_out_auto_prog[index].configUseYn = value;
      }
    });
  }

  /**
   * 설정-외부 프로그램 주문 자동 완료
   * 각 토글 값
   */
  @observable
  _st_setting_each_auto_prog = {
    key: "",
    val: "",
  };

  @computed
  get getSettingEachAutoProg() {
    return this._st_setting_each_auto_prog;
  }

  @action
  setSettingEachAutoProg(key, value) {
    return (this._st_setting_each_auto_prog = {
      ...this._st_setting_each_auto_prog,
      [key]: value,
    });
  }

  /**
   * 유/무료 조회
   */
  @observable
  _st_pay_free_type = {
    paymentUseYn: "",
    useDeliveryResList: [],
  };

  get getPayFreeType() {
    return this._st_pay_free_type;
  }

  @action
  setPayFreeType(type) {
    this._st_pay_free_type.paymentUseYn = type;
  }

  @action
  setPayFreeList(list) {
    this._st_pay_free_type.useDeliveryResList = list;
  }

  /**
   * 공지사항목록조회
   * @returns {{currentPage: number, maxPage: number}}
   */
  @observable
  _st_notice_list = {
    currentPage: 1,
    maxPage: 1,
    id: "0",
    notices: [],
  };

  get getNoticeId() {
    return this._st_notice_list.id;
  }

  get getNoticePagingInfo() {
    return this._st_notice_list;
  }

  get getNoticeList() {
    return this._st_notice_list.notices;
  }

  @action
  setNoticeId(n) {
    this._st_notice_list.id = n;
  }

  @action
  setNoticePagingInfo(key, value) {
    this._st_notice_list = { ...this._st_notice_list, [key]: value };
  }

  @action
  setNoticeList(list) {
    this._st_notice_list.notices = list;
  }

  @observable
  _st_notice_detail_list = [];

  get getNoticeDetailList() {
    return this._st_notice_detail_list;
  }

  @action
  setNoticeDetailList(list) {
    this._st_notice_detail_list = list;
  }

  /**
   * 알림new표시
   *
   */
  @observable
  _st_notice_new = "";

  get getNoticeNew() {
    return this._st_notice_new;
  }

  @action
  setNoticeNew(type) {
    this._st_notice_new = type;
  }

  /**
   * 긴급공지
   *
   */
  @observable
  _st_emergency_notice = {
    title: "",
    content: "",
    type: "",
  };

  @computed
  get getEmergencyNotice() {
    return this._st_emergency_notice;
  }

  @action
  setEmergencyNotice(key, value) {
    this._st_emergency_notice = { ...this._st_emergency_notice, [key]: value };
  }

  /**
   * 연동가능 배달대행사 목록
   *
   */
  @observable
  _st_dlv_possible_list = false;

  get getPossibleList() {
    return this._st_dlv_possible_list;
  }

  @action
  setPossibleList(type) {
    this._st_dlv_possible_list = type;
  }

  //user정보
  @observable
  _st_user_info = {
    userId: "",
    userNm: "",
  };

  @computed
  get getUserInfo() {
    return this._st_user_info;
  }
  @action
  setUserInfo(key, value) {
    this._st_user_info = { ...this._st_user_info, [key]: value };
  }

  /**
   * 관리자설정 설정 view 여부
   */
  @observable
  _st_setting_manager_setting = {
    realTime: "", //관리자설정 실시간매출보기 여부
    salePage: "", //관리자설정 매출분석페이지 보기 여부
    orderEnd: "N", //메인페이지 완료주문 보기 여부(toggle)
  };

  get getManagerSetting() {
    return this._st_setting_manager_setting;
  }

  @action
  setManagerSettingFlag(com) {
    return (this._st_setting_manager_setting = com);
  }

  @action
  setManagerSetting(key, value) {
    this._st_setting_manager_setting = {
      ...this._st_setting_manager_setting,
      [key]: value,
    };
  }

  @observable
  _st_login_info = [];

  @computed
  get getLoginInfo() {
    return this._st_login_info;
  }
  @action
  setLoginInfo(com) {
    this._st_login_info = com;
  }

  /**
   * 암호화된 shopCd
   * @type {string}
   * @private
   */
  @observable
  _st_shop_api_setting = {};

  @action
  setShopApiSetting(list) {
    this._st_shop_api_setting = list;
  }

  get getShopApiSetting() {
    return this._st_shop_api_setting;
  }

  /**
   * select scroll cnt
   *
   */
  @observable
  _st_select_scroll_cnt = 0;

  get getSelectScrollCnt() {
    return this._st_select_scroll_cnt;
  }

  @action
  setSelectScrollCnt(cnt) {
    this._st_select_scroll_cnt = cnt;
  }

  /**
   * 연동하기 결과 팝업 값
   *
   */
  @observable
  _st_dlv_connect_result = "";

  get getDlvConnectResult() {
    return this._st_dlv_connect_result;
  }

  @action
  setDlvConnectResult(val) {
    this._st_dlv_connect_result = val;
  }

  /**
   * 배달대행사 정보 (사업자번호, 코드...)
   *
   */
  @observable
  _st_dlv_regist_info = {
    businessNumber: "",
    autoMappingYn: "",
    deliveryCode: "",
    subDeliveryCode: "",
    deliveryServiceName: "",
    parentDeliveryServiceName: "",
    telNo: "",
    contactPossibleTime: "",
    shopName: "",
    activate: true,
    agencyCode: "",
    storeTel: "",
  };

  get getDlvRegistInfo() {
    return this._st_dlv_regist_info;
  }

  @action
  setDlvRegistInfo(key, value) {
    this._st_dlv_regist_info = { ...this._st_dlv_regist_info, [key]: value };
  }

  /**
   * pos notify sound
   *
   */
  @observable
  _st_pos_notify_sound = "default";

  get getPosNotifySound() {
    return this._st_pos_notify_sound;
  }

  @action
  setPosNotifySound(val) {
    this._st_pos_notify_sound = val;
  }

  /**
   * 배달대행사 selectBox
   */
  @observable
  _st_dlv_select_list_view = false;

  @computed
  get getDlvSelectListView() {
    return this._st_dlv_select_list_view;
  }

  @action
  setDlvSelectListView(bl) {
    this._st_dlv_select_list_view = bl;
  }

  /**
   * 원산지 출력 설정
   */
  @observable
  _st_origin_setting_info = {
    originInfoYn: "",
    originInfo: "",
  };

  get getOriginSettingInfo() {
    return this._st_origin_setting_info;
  }

  @action
  setOriginSettingInfoYn(flag) {
    let val = flag == true ? "Y" : "N";
    this._st_origin_setting_info.originInfoYn = val;
  }

  @action
  setOriginSettingInfo(key, value) {
    this._st_origin_setting_info = {
      ...this._st_origin_setting_info,
      [key]: value,
    };
  }

  //배민 서비스 연동 상태
  @observable
  _st_baemin_service_status = {};

  @computed
  get getBaeminStatus() {
    return this._st_baemin_service_status;
  }

  @action
  setBaeminStatus(com) {
    this._st_baemin_service_status = com;
  }

  //배민 에이전시 사용 상태
  @observable
  _st_baemin_service_use = {
    isCurrentPosBaeminUse: "",
    baeminUsePosNo: "",
    baeminStatus: "",
  };

  @computed
  get getBaeminUseStatus() {
    return this._st_baemin_service_use;
  }

  @action
  setBaeminUseStatus(key, value) {
    this._st_baemin_service_use = { ...this._st_baemin_service_use, [key]: value };
  }

  //요기요 예상 조리시간 선택
  @observable
  _st_cook_time_list = [];

  @computed
  get getCookTimeList() {
    return this._st_cook_time_list;
  }
  @action
  setCookTimeList(val) {
    this._st_cook_time_list = val;
  }

  //요기요 예상 조리시간
  @observable
  _st_cook_time_ygy = "";

  @computed
  get getCookTimeYgy() {
    return this._st_cook_time_ygy;
  }
  @action
  setCookTimeYgy(val) {
    this._st_cook_time_ygy = val;
  }

  //요기요 연동 여부
  @observable
  _st_ygy_service_use = "";

  @computed
  get getYgyUseStatus() {
    return this._st_ygy_service_use;
  }
  @action
  setYgyUseStatus(val) {
    this._st_ygy_service_use = val;
  }

  // 주문접수 연동 설정
  @observable
  AppConnectToggle = true;

  @computed
  get getAppConnectToggle() {
    return this.AppConnectToggle;
  }

  @action
  setAppConnectToggle(bool) {
    this.AppConnectToggle = bool;
  }

  /**
   * 메인 배달대행사 (예상 배달비 조회)
   *
   */
  @observable
  _st_main_dlv = "";

  get getMainDlv() {
    return this._st_main_dlv;
  }

  @action
  setMainDlv(type) {
    this._st_main_dlv = type;
  }

  /**
   * 배달대행사 사용여부 item
   *
   */
  @observable
  _st_check_dlv = "";

  get getCheckDlv() {
    return this._st_check_dlv;
  }

  @action
  setCheckDlv(type) {
    this._st_check_dlv = type;
  }

  /**
   * 사용포스 목록 조회
   *
   */
  @observable
  _st_use_pos_list = [];

  get getUsePosList() {
    return this._st_use_pos_list;
  }

  @action
  setUsePosList(obj) {
    this._st_use_pos_list = obj;
  }

  /**
   * 요기요 가게목록 조회
   *
   */
  @observable
  _st_ygy_shop_list = [];

  get getYgyShopList() {
    return this._st_ygy_shop_list;
  }

  @action
  setYgyShopList(obj) {
    this._st_ygy_shop_list = obj;
  }

  /**
   * 땡겨요 가게목록 조회
   *
   */
  @observable
  _st_ddy_shop_list = [];

  get getDdyShopList() {
    return this._st_ddy_shop_list;
  }

  @action
  setDdyShopList(obj) {
    this._st_ddy_shop_list = obj;
  }

  /**
   * 배달앱 사업자번호
   *
   */
  @observable
  _st_shop_bizNo = "";

  get getShopBizNo() {
    return this._st_shop_bizNo;
  }

  @action
  setShopBizNo(obj) {
    this._st_shop_bizNo = obj;
  }

  /**
   * 연동 출력물 설정 값(주문전표)
   *
   */
  @observable
  _st_print_out_receipt0 = {
    title: "5",
    channelNo: "5",
    posNo: "5",
    loadAdr: "5",
    adress: "1",
    phone: "5",
    memo: "5",
    menu: "5",
    option: "5",
    payMethod: "5",
    shopNm: "1",
    orderTime: "1",
  };

  get getPrintOutReceipt0() {
    return this._st_print_out_receipt0;
  }

  @action
  setPrintOutReceipt0(key, value) {
    this._st_print_out_receipt0 = { ...this._st_print_out_receipt0, [key]: value };
  }

  @action
  initPrintOutReceipt0(key, val) {
    this._st_print_out_receipt0 = {
      title: "5",
      channelNo: "5",
      posNo: "5",
      loadAdr: "5",
      adress: "1",
      phone: "5",
      memo: "5",
      menu: "5",
      option: "5",
      payMethod: "5",
      shopNm: "1",
      orderTime: "1",
    };
  }

  /**
   * 연동 출력물 설정 값(주문서)
   *
   */
  @observable
  _st_print_out_receipt1 = {
    title: "5",
    channelNo: "5",
    posNo: "5",
    memo: "5",
    menu: "5",
    option: "5",
    payMethod: "5",
    orderTime: "1",
  };

  get getPrintOutReceipt1() {
    return this._st_print_out_receipt1;
  }

  @action
  setPrintOutReceipt1(key, value) {
    this._st_print_out_receipt1 = { ...this._st_print_out_receipt1, [key]: value };
  }

  @action
  initPrintOutReceipt1(key, val) {
    this._st_print_out_receipt1 = {
      title: "5",
      channelNo: "5",
      posNo: "5",
      memo: "5",
      menu: "5",
      option: "5",
      payMethod: "5",
      orderTime: "1",
    };
  }

  /**
   * 연동 출력물 설정 주문전표 조회
   *
   */
  @observable
  _st_print_out_list_hall = [];

  get getPrintOutListHall() {
    return this._st_print_out_list_hall;
  }

  @action
  setPrintOutListHall(obj) {
    this._st_print_out_list_hall = obj;
  }

  /**
   * 연동 출력물 설정 주문서 조회
   *
   */
  @observable
  _st_print_out_list_kitchen = [];

  get getPrintOutListKitchen() {
    return this._st_print_out_list_kitchen;
  }

  @action
  setPrintOutListKitchen(obj) {
    this._st_print_out_list_kitchen = obj;
  }

  /**
   * 미처리 주문 list
   *
   */
  @observable
  _st_return_fail_list = [];

  get getReturnFailList() {
    return this._st_return_fail_list;
  }

  @action
  setReturnFailList(obj) {
    this._st_return_fail_list = obj;
  }

  /**
   * 미처리 주문 onClick
   *
   */
  @observable
  _st_return_fail_on = {
    mobileOrderNo: "",
    pendingNo: "",
  };

  get getReturnFailOn() {
    return this._st_return_fail_on;
  }

  @action
  setReturnFailOn(key, value) {
    this._st_return_fail_on = { ...this._st_return_fail_on, [key]: value };
  }

  /**
   * 에이전시 매장 휴부 여부
   *
   */
  @observable
  _st_agency_holiday_state = false;

  get getAgencyHolidayState() {
    return this._st_agency_holiday_state;
  }

  @action
  setAgencyHolidayState(type) {
    this._st_agency_holiday_state = type;
  }

  /**
   * 키오스크 주문 여부
   *
   */
  @observable
  _st_pos_order_list = false;

  get getPosOrderList() {
    return this._st_pos_order_list;
  }

  @action
  setPosOrderList(type) {
    this._st_pos_order_list = type;
  }

  /**
   * 키오스크 주문 상태
   *
   */
  @observable
  _st_kiosk_order_state = "all";

  get getKioskOrderState() {
    return this._st_kiosk_order_state;
  }

  @action
  setKioskOrderState(type) {
    this._st_kiosk_order_state = type;
  }
}

export default new SettingStore();
